import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminHeader } from '../../../shared/components';
import StudentsList from './StudentsList';

/**
 * Componente principal de gestión de Alumnos
 * Mantiene el header de navegación consistente con AdminDashboard
 */
const StudentsManagement = ({ adminData, onLogout }) => {
  const navigate = useNavigate();

  // Manejar volver al dashboard
  const handleBackToDashboard = () => {
    navigate('/admin');
  };

  return (
      <div className="min-h-screen bg-gray-50">
        {/* Header consistente */}
        <AdminHeader
          adminData={adminData}
          onLogout={onLogout}
          showBackButton={true}
          onBackClick={handleBackToDashboard}
          backButtonText="Volver al Dashboard"
        />

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Contenido principal */}
          <StudentsList />
        </main>
      </div>
  );
};

export default StudentsManagement;